import { type CarrierContactFragment, CarrierContactType } from "@qw/graphql";
import { Group } from "@qw/ui";

import { CarrierContactList } from "./carrier-contact-list";

interface Props {
  productId: string;
  submissionContacts: CarrierContactFragment[];
  referenceContacts: CarrierContactFragment[];
  canEdit: boolean;
}

export const CarrierContactsSection: React.FC<Props> = ({
  productId,
  submissionContacts,
  referenceContacts,
  canEdit,
}) => {
  return (
    <Group className="gap-6">
      <CarrierContactList
        type={CarrierContactType.Submission}
        contacts={submissionContacts}
        appetiteProductId={productId}
        canEdit={canEdit}
      />
      <CarrierContactList
        type={CarrierContactType.Reference}
        contacts={referenceContacts}
        appetiteProductId={productId}
        canEdit={canEdit}
      />
    </Group>
  );
};
